/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerListProjectSightContractsQueryResponse, TrimbleItemsControllerListProjectSightContractsQueryParams, TrimbleItemsControllerListProjectSightContracts401, TrimbleItemsControllerListProjectSightContracts403 } from "../../models/trimbleController/TrimbleItemsControllerListProjectSightContracts";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleItemsControllerListProjectSightContracts } from "../../clients/trimbleService/trimbleItemsControllerListProjectSightContracts";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleItemsControllerListProjectSightContractsQueryKey = (params: TrimbleItemsControllerListProjectSightContractsQueryParams) => [{
  url: '/api/v1/trimble/projectsight/contracts'
}, ...(params ? [params] : [])] as const;
export type TrimbleItemsControllerListProjectSightContractsQueryKey = ReturnType<typeof trimbleItemsControllerListProjectSightContractsQueryKey>;
export function trimbleItemsControllerListProjectSightContractsQueryOptions(params: TrimbleItemsControllerListProjectSightContractsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleItemsControllerListProjectSightContractsQueryKey(params);
  return queryOptions<TrimbleItemsControllerListProjectSightContractsQueryResponse, ResponseErrorConfig<TrimbleItemsControllerListProjectSightContracts401 | TrimbleItemsControllerListProjectSightContracts403>, TrimbleItemsControllerListProjectSightContractsQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleItemsControllerListProjectSightContracts(params, config);
    }
  });
}

/**
 * @summary List the connected ProjectSight project's contracts and their attached files
 * {@link /api/v1/trimble/projectsight/contracts}
 */
export function useTrimbleItemsControllerListProjectSightContracts<TData = TrimbleItemsControllerListProjectSightContractsQueryResponse, TQueryData = TrimbleItemsControllerListProjectSightContractsQueryResponse, TQueryKey extends QueryKey = TrimbleItemsControllerListProjectSightContractsQueryKey>(params: TrimbleItemsControllerListProjectSightContractsQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrimbleItemsControllerListProjectSightContractsQueryResponse, ResponseErrorConfig<TrimbleItemsControllerListProjectSightContracts401 | TrimbleItemsControllerListProjectSightContracts403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleItemsControllerListProjectSightContractsQueryKey(params);
  const query = useQuery({
    ...trimbleItemsControllerListProjectSightContractsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrimbleItemsControllerListProjectSightContracts401 | TrimbleItemsControllerListProjectSightContracts403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}